// extracted by mini-css-extract-plugin
export default {"LoginLayout":"LoginLayout_LoginLayout__49DfZ"};